import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { logout } from "../actions/user";
import Menu from "../components/Menu";

const mapStateToProps = (state, { path }) => {
  return { path };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logout,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
